"use client";

import { ChevronLeft, ChevronRight } from "lucide-react";



import { useSmartTableModelContext } from "./smart-table-model-context";

export function SmartTablePagination<TData>() {
  const m = useSmartTableModelContext<TData>();
  const { total, page, pageSize, isLoading, error, onPageChange, onPageSizeChange, t, totalPages, startItem, endItem, Button, Select } = m;
  return (
    <>
      {!isLoading && error === null && (
        <div className="flex items-center justify-between">
          <div className="text-sm text-text-secondary">
            {t("table.page.showing")} {startItem}-{endItem} {t("table.page.of")}{" "}
            {total}
          </div>
          <div className="flex items-center gap-2">
            <Select
              size="sm"
              value={String(pageSize)}
              onChange={(v) => onPageSizeChange(Number(v))}
              ariaLabel={t("table.page.aria.size")}
              className="w-auto min-w-[90px]"
              options={[25, 50, 100, 200].map((s) => ({
                value: String(s),
                label: `${s}${t("table.page.perPage")}`,
              }))}
            />
            <Button
              variant="outline"
              size="icon"
              disabled={page <= 1}
              onClick={() => onPageChange(page - 1)}
              aria-label={t("table.page.previous")}
            >
              <ChevronLeft className="h-4 w-4" />
            </Button>
            <span className="text-sm">
              {page} / {totalPages}
            </span>
            <Button
              variant="outline"
              size="icon"
              disabled={page >= totalPages}
              onClick={() => onPageChange(page + 1)}
              aria-label={t("table.page.next")}
            >
              <ChevronRight className="h-4 w-4" />
            </Button>
          </div>
        </div>
      )}
    </>  );
}
